export default {
    courses: {
        list: null,
        single: null
    },

    enrollments: {
        list: null,
        single: null
    },

    learners: {
        list: null,
        single: null
    },

    lessons: {
        list: null,
        single: null
    },

    managers: {
        list: null,
        single: null
    },

    materials: {
        list: null,
        single: null
    },

    meetings: {
        list: null,
        single: null
    },

    memberships: {
        list: null,
        single: null
    },

    packs: {
        list: null,
        single: null
    },

    payments: {
        list: null,
        single: null
    },

    requests: {
        list: null,
        single: null
    },

    rooms: {
        list: null,
        single: null
    },

    settings: null,

    teachers: {
        list: null,
        single: null
    },

    user: null
};